/* eslint-disable max-len */
import Permission from './permission'

import * as Pages from './pages'
import * as Forms from './components/forms'
import * as Reports from './reports'
import * as Mixed from './components/mixed'

// Permissions Pre-route
const Requires = (requests, redirect) => ({
  beforeEnter: (to, from, next) => {
    if (Permission.has(requests))
      next()
    else
      next(redirect || '/forbidden')
  },
})

export default [
  { path: '/login', name: 'login', component: Pages.Login, meta: { title: '登陆' } },
  {
    path: '/',
    component: Pages.Main,
    children: [{
      path: '',
      name: 'dashboard',
      component: Pages.Dashboard,
      meta: { title: '总览' },
      ...Requires('basic.view.rooms', '/login'),
      children: [
        { path: 'bills', component: Pages.Bills, meta: { title: '收支明细' }, ...Requires('basic.view.bills') },
        { path: 'customers', component: Pages.Customers, meta: { title: '住户信息' }, ...Requires('basic.view.customers') },
        { path: 'properties', component: Pages.Properties, meta: { title: '库存信息' }, ...Requires('basic.view.properties') },
        { path: 'charges', component: Pages.Charges, meta: { title: '水电费充值记录' } },
        {
          path: 'admin',
          component: Pages.Admin,
          meta: { title: '系统管理' },
          props: true,
          ...Requires('system.admin'),
          children: [
            { path: 'users', component: Pages.UserManagement, meta: { title: '用户管理' }, ...Requires('system.users.edit') },
            { path: 'templates', component: Pages.TemplatesManagement, meta: { title: '模板管理' }, ...Requires('system.templates.edit') },
            { path: 'rooms', component: Pages.RoomsManagement, meta: { title: '房间管理' }, ...Requires('basic.rooms.edit') },
            { path: 'meta', component: Pages.MetaManagement, meta: { title: '资料管理' }, ...Requires('system.meta.edit') },
          ],
        },
        {
          path: 'room/:no',
          component: Pages.Room,
          props: true,
          children: [
            { path: '', component: Mixed.RoomDetail, props: true },
            { path: 'edit', component: Forms.FormEditRoom, props: true, meta: { title: '更改房间信息' }, ...Requires('basic.modify.rooms') },
            { path: 'preorder', component: Forms.FormNewPreorder, props: true, meta: { title: '预定房间' }, ...Requires('basic.create.preorders') },
            { path: 'utilities', component: Forms.FormUtilities, props: true, meta: { title: '更新水电信息' }, ...Requires('basic.modify.utilities') },
            { path: 'utilities_settle', component: Forms.FormUtilitiesSettle, props: true, meta: { title: '结算水电', action: true }, ...Requires('basic.create.charges') },
            { path: 'charge_lezhu', component: Forms.FormChargeLezhu, props: true, meta: { title: '空房智能电表充值', action: true }, ...Requires('basic.create.charges') },
            { path: 'sign', component: Forms.FormSignContract, props: true, meta: { title: '新签合同' }, ...Requires('basic.create.contracts') },
            { path: 'sign/by/:preorder_id', component: Forms.FormSignContract, props: true, meta: { title: '新签合同' }, ...Requires('basic.create.contracts') },
            { path: 'sign/load/:load_draft_key', component: Forms.FormSignContract, props: true, meta: { title: '新签合同' }, ...Requires('basic.create.contracts') },
            { path: 'sign/renew/:renew_contract_id', component: Forms.FormSignContract, props: true, meta: { title: '续签合同' }, ...Requires('basic.create.contracts') },
            {
              path: 'contract/:contract_id',
              component: Mixed.ContractDetail,
              props: true,
              children: [
                { path: 'rent', name: 'rent', component: Forms.FormNewRent, props: true, meta: { title: '续交租金', action: true }, ...Requires('basic.create.rents') },
                { path: 'rent_by_day', name: 'rent_by_day', component: Forms.FormNewRentByDay, props: true, meta: { title: '按日续交租金', action: true }, ...Requires('basic.create.rents') },
                { path: 'checkout', name: 'checkout', component: Forms.FormCheckout, props: true, meta: { title: '退房', action: true }, ...Requires('basic.modify.contracts.checkout') },
                { path: 'charge', name: 'charge', component: Forms.FormCharge, props: true, meta: { title: '水电充值', action: true }, ...Requires('basic.create.charges') },
                { path: 'utilities_settle', component: Forms.FormUtilitiesSettle, props: true, meta: { title: '结算水电', action: true }, ...Requires('basic.create.charges') },
                { path: 'charge_lezhu', name: 'charge_lezhu', component: Forms.FormChargeLezhu, props: true, meta: { title: '智能电表充值', action: true }, ...Requires('basic.create.charges') },
                { path: 'transfer_delegation', component: Forms.FormTransferDelegation, props: true, meta: { title: '签署转让委托', action: true }, ...Requires('basic.create.transfer_delegations') },
              ],
              ...Requires(['basic.view.contracts', 'basic.view.charges', 'basic.view.preorders', 'basic.view.rents']),
            },
          ],
          ...Requires('basic.view.rooms'),
        },
        {
          path: 'records',
          component: Pages.Records,
          meta: { title: '信息记录' },
          children: [
            { path: 'meters', component: Forms.FormRecordMeters, meta: { title: '公寓水电表记录' } },
          ],
          ...Requires('basic.record'),
        },
        {
          path: 'reports',
          component: Reports.Root,
          meta: { title: '报表' },
          children: [
            { path: 'meters', component: Reports.Meters, meta: { title: '公寓水电使用报表' } },
            { path: 'charges', component: Reports.Charges, meta: { title: '水电充值报表' } },
            { path: 'rents', component: Reports.Rents, meta: { title: '租金报表' } },
            { path: 'month', component: Reports.Month, meta: { title: '月汇总报表' } },
            { path: 'summary', component: Reports.Summary, meta: { title: '年度汇总报表' } },
            { path: 'subjects', component: Reports.Subjects, meta: { title: '科目汇总报表' } },
            { path: 'utilities_monitor', component: Reports.UtilitiesMonitor, meta: { title: '水电监控' } },
          ],
          ...Requires('basic.view.reports'),
        },
        { path: 'profile', component: Pages.UserProfile, props: true, meta: { title: '用户信息' } },
        { path: 'forbidden', component: Pages.Forbidden, props: true, meta: { title: '无权限' } },
      ],
    },
    { path: '*', component: Pages.PageNotFound, meta: { title: '未找到请求页面' } },
    ],
  },
]



// WEBPACK FOOTER //
// ./client/src/routers.js